import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.group_dropdown';

export default defineMessages({
  current_project: {
    id: `${scope}.current_project`,
    defaultMessage: 'CURRENT PROJECT',
  },
  toggle_dropdown: {
    id: `${scope}.toggle_dropdown`,
    defaultMessage: 'Toggle Dropdown',
  },
});
